import { render } from "./SensorReadings.vue?vue&type=template&id=0a8fc7d8&scoped=true&bindings={}"
import script from "./SensorReadings.vue?vue&type=script&lang=js"
export * from "./SensorReadings.vue?vue&type=script&lang=js"

import "./SensorReadings.vue?vue&type=style&index=0&id=0a8fc7d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a8fc7d8"

export default script